import cloneDeep from 'lodash/cloneDeep';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  const data = cloneDeep(serverTableData);
  if (data.orderBy === 'dateRealisation') {
    data.orderBy = 'dateValidite';
  }
  if (data.orderBy === 'datePlanification') {
    data.orderBy = 'datePremierAffichage';
  }
  if (data.orderBy === 'dateSouhaitee') {
    data.orderBy = 'dateDevisCommande';
  }

  if (data.orderBy === undefined || data.orderBy === '') {
    data.orderBy = 'creationTime';
    data.ascending = false;
  }
  if (data.query?.dates && !data.query.dates.dateDebut && !data.query.dates.dateFin) {
    delete data.query.dates;
  }
  if (data.query?.datesPremierAffichage && !data.query.datesPremierAffichage.dateDebut
    && !data.query.datesPremierAffichage.dateFin) {
    delete data.query.datesPremierAffichage;
  }
  if (data.query?.datesValidite && !data.query.datesValidite.dateDebut
    && !data.query.datesValidite.dateFin) {
    delete data.query.datesValidite;
  }
  if (data.query?.datesFacture && !data.query.datesFacture.dateDebut
    && !data.query.datesFacture.dateFin) {
    delete data.query.datesFacture;
  }
  return generalTransformer(data);
}
